$(function() {
  var $accordion, $accordionItem, $accordionNav, $links, accordionClass, accordionItemActiveClass, accordionItemClass, accordionNavClass;
  accordionClass = "accordion";
  accordionItemClass = accordionClass + "__item";
  accordionItemActiveClass = accordionItemClass + "--active";
  accordionNavClass = accordionClass + "__nav";
  if ($("." + accordionClass).length) {
    $accordion = $("." + accordionClass);
    $accordionItem = $accordion.find("." + accordionItemClass);
    $accordionNav = $accordion.find("." + accordionNavClass);
    $accordionNav.on('click', function(e) {
      var $selected;
      if (!$(e.target).is('.pdf-link, .pdf-link *')) {
        $selected = $(this).parents("." + accordionItemClass);
        e.preventDefault();
        if (!$selected.hasClass(accordionItemActiveClass)) {
          $accordionItem.removeClass(accordionItemActiveClass);
          $accordionItem.find('.accordion__content').attr('style', '');
          $('html, body').stop(true, false).animate({
            scrollTop: $selected.offset().top
          }, 100, 'swing', function() {
            $selected.find('.accordion__content').slideDown(100);
            return $selected.addClass(accordionItemActiveClass);
          });
        } else {
          $selected.removeClass(accordionItemActiveClass);
          $selected.find('.accordion__content').attr('style', '');
        }
        return e.preventDefault();
      }
    });
  }
  $links = $('.tabs-content__mobile-link');
  if ($links.length) {
    return $links.on('click', function(e) {
      var tabId;
      $(this).parents('.tabs-content').find('.tabs-content__mobile-link--open').removeClass('tabs-content__mobile-link--open');
      $(this).addClass('tabs-content__mobile-link--open');
      e.preventDefault();
      tabId = $(this).attr('href').split("#tabContent-")[1];
      $("#tab-" + tabId).click();
      return scrollToElement($(this), 57, 0);
    });
  }
});

// ---
// generated by coffee-script 1.9.2